import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import {
			Container,
			Button,
			Icon,
			Image,
			Grid,
			TabPane,
			Tab,
			ListItem,
			ListHeader,
			ListDescription,
			ListContent,
			List,
 	} from 'semantic-ui-react'
import moment from 'moment'

// import game_model from 'models/game_model'
import game_play_model from 'models/game_play_model'

import ord_arr_by_spec from 'xAppLib/helpers/ord_arr_by_spec'

import GamePlayEntry from 'views/UIelems/GamePlayEntry';


let stats_count = {}

const STATS_DICT = {
	win: 'won',
	end: 'ended/no-win',
	guess: 'started guessing',
	start: 'started typing',
	open: 'opened only',
}

const Leaderboard = props => {

	const show_list = stat => <>
			<h5>Games {STATS_DICT[stat]}</h5>

			<List>
			{
				game_plays?.filter(game => game.stat === stat)
					.sort((a, b) => {
									if (a.mvs?.length != b.mvs?.length)
										return a.mvs?.length - b.mvs?.length

									if (a.mvs?.[a.mvs?.length-1]?.t != b.mvs?.[b.mvs?.length-1]?.t)
										return a.mvs?.[a.mvs?.length-1]?.t - b.mvs?.[b.mvs?.length-1]?.t

									return a.tm?.seconds||0 - b.tm?.seconds||0
								} )
					.map((game, i) => <ListItem key={i}>
								<ListContent>
									<GamePlayEntry
										play={game}
										showPlayer={true}
										showMoveTimes={true}
										showStatus={false}
										showDate={true}
										showTotalTime={true}
										showMoveCount={true}
										layout="list"
									/>
								</ListContent>
							</ListItem>
					)
			}
			</List>

		</>



	const show_tabs = _=> ord_arr_by_spec(Object.keys(stats_count), ['win', 'end', 'guess', 'start', 'open']).map((stat, i) => ({menuItem: STATS_DICT[stat] + '  (' + stats_count[stat] + ')', render: () => <TabPane key={i}>{show_list(stat)}</TabPane> }) )


	const [game_plays, setGame_plays] = useState()
	// const [gpid, setGpid] = useState()

	// const word = WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)]

	const gid = props.match?.params?.gid || props?.gid

	useEffect( async _ => {

		const _game_plays = await game_play_model.load_game_plays(gid)

		stats_count = _game_plays?.reduce((acc, curr) => {
			acc[curr.stat] = (acc[curr.stat] || 0) + 1;
			return acc;
		}, {});


		setGame_plays(_game_plays)

		// console.log('game_plays loaded ', _game_plays, gid);

	}, [gid])

	return <Container text>

		<div style={{textAlign: 'center'}}>

			<h2>Leaderboard</h2>

			<p className="text-sm md:text-base" style={{ wordBreak: 'break-word' }}>
				{game_plays?.[0]?.game} &nbsp; / &nbsp;
				<i>{game_plays?.[0]?.gid}</i> &nbsp; / &nbsp;
				<b>"{game_plays?.[0]?.p?.word}"</b> &nbsp; / &nbsp;
				{game_plays?.[0]?.p?.max_guesses} guesses &nbsp; / &nbsp;
				use dictionary: {game_plays?.[0]?.p?.dict?.toString()}
			</p>

		</div>

		{
			props.type=='admin'
				&& <Tab panes={show_tabs()} />
				|| show_list('win')
		}
		
		{/*<pre>
			{JSON.stringify(stats_count, null, 4)}
		</pre>
		<pre>
			{JSON.stringify(game_plays, null, 4)}
		</pre>*/}

		</Container>
}

export default Leaderboard;